// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j9NT","delete":"styles_delete__3Wu7A","update":"styles_update__33I3C","add":"styles_add__2Xpgr"};